const genericLoaderId = "genericLoadSpinner";
let loaderCount = 0;


export const showLoadSpinner = () => {
    loaderCount++;
    var element = document.getElementById(genericLoaderId);

    if (element) {
        element.classList.add("active");
    }
};

export const hideLoadSpinner = (resetCount) => {
    loaderCount--;
    var element = document.getElementById(genericLoaderId);

    if (loaderCount < 0 || resetCount) {
        loaderCount = 0;
    }
    
    if (element && loaderCount === 0) {
        setTimeout(() => {
            element.classList.remove("active");
        }, 100);
    }
};
